<script>
	import { _ } from 'svelte-i18n'
	import PreviewsStepperButton from './PreviewsStepperButton.svelte'
	import { previews_font_size, previews_min_font_size, previews_max_font_size } from './../stores.js'

	let increase_disabled = false
	let decrease_disabled = false
	
  function increase() {
    if (!increase_disabled) $previews_font_size++
  }
	function decrease(){
		if (!decrease_disabled) $previews_font_size--
	}
	$: {
		if ($previews_font_size == $previews_min_font_size) decrease_disabled = true
		else decrease_disabled = false
		if ($previews_font_size == $previews_max_font_size) increase_disabled = true
		else increase_disabled = false
		localStorage.setItem("previews_font_size", $previews_font_size)
		console.log("Previews - font size changed to:" + $previews_font_size)
	}
</script>

<div class="wrapper">
	<PreviewsStepperButton on:click={decrease} disabled={decrease_disabled}>{$_('buttons.smaller')}</PreviewsStepperButton>
  <span> / </span>
  <PreviewsStepperButton on:click={increase} disabled={increase_disabled}>{$_('buttons.bigger')}</PreviewsStepperButton>
</div>

<style>
  .wrapper {
    margin-right: 4rem;
		cursor: default;
  }
  span {
    color: var(--c-text-faded-big);
		user-select: none;
  }
</style>